import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

import axios from 'axios'
 
Vue.use(VueRouter)
 

const routes = [{
		path: '/',
		name: 'home',
		component: HomeView,
		meta:{
			title:'品牌首页'
		}
	},
	{
		path: '/goods/typeList',
		name: '产品中心',
		component: () => import('../views/goods/TypeList.vue'),
		meta:{
			title:'产品中心'
		}
	},{
		path: '/goods/productDetail',
		name: '商品详情',
		component: () => import('../views/goods/ProductDetail.vue'),
		meta:{
			title:'商品详情'
		}
	},
	{
		path: '/case/list',
		name: '案例列表',
		component: () => import('../views/case/List.vue'),
		meta:{
			title:'案例中心'
		}
	},
	{
		path: '/case/detail',
		name: '案例详情',
		component: () => import('../views/case/Detail.vue'),
		meta:{
			title:'案例详情'
		}
	},
	{
		path: '/businessCooperation',
		name: '招商加盟',
		component: () => import('../views/BusinessCooperation.vue'),
		meta:{
			title:'招商加盟'
		}
	},
	{
		path: '/my/myIndex',
		name: '个人中心',
		component: () => import('../views/my/MyIndex.vue'),
		meta:{
			title:'个人中心'
		}
	},{
		path: '/materialReplaceProject/list',
		name: '材质替换列表',
		component: () => import('../views/materialReplaceProject/List.vue'),
		meta:{
			title:'材质替换列表'
		}
	},{
		path: '/materialReplaceProject/detail',
		name: '材质替换详情',
		component: () => import('../views/materialReplaceProject/Detail.vue'),
		meta:{
			title:'材质替换详情'
		}
	},{
		path: '/materialReplaceProject/detail2',
		name: '产品替换详情',
		component: () => import('../views/materialReplaceProject/Detail2.vue'),
		meta:{
			title:'材质替换详情'
		}
	},{
		path: '/eshop/list',
		name: '数字门店列表',
		component: () => import('../views/eshop/List.vue'),
		meta:{
			title:'数字门店列表'
		}
	},{
		path: '/eshop/detail',
		name: '数字门店详情',
		component: () => import('../views/eshop/Detail.vue'),
		meta:{
			title:'数字门店详情'
		}
	},
	{
		path: '/company/companyInfo',
		name: '公司信息',
		component: () => import('../views/company/CompanyInfo.vue'),
		meta:{
			title:'联系我们'
		}
	},
	{
		path: '/error',
		name: '错误页面',
		component: () => import('../views/Error.vue'),
		meta:{
			title:'错误页面'
		}
	},
	{
		path: '/jumper',
		name: '加载中转页面',
		component: () => import('../views/Jumper.vue'),
		meta:{
			title:'加载中...'
		}
	}
]

const router = new VueRouter({
	routes
})

/*******************************************************************************
 * 解决导航重复报错的问题
 * 参考：https://www.jianshu.com/p/1e462d9b0c03 
 *******************************************************************************/
  
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

/******************************************************************************* 
 *******************************************************************************/
 
 // 动态修改页面显示title   
 let changeTitle = function(_mainBody ,to){  
	   
 	if(to.meta.title){
 		document.title =  (_mainBody?_mainBody.name:'') + ' ' +to.meta.title;
 	}else{
 		document.title = _mainBody?_mainBody.name:'品迈科技';
 	}
 }
 
 //路由守卫
 //使用router.beforeEach 注册一个全局前置守卫，判断用户是否登录
 router.beforeEach((to, from, next)=>{
	
	let _MAINBODY = localStorage.getItem('MAINBODY');
	let _mainBody = null;
	if(_MAINBODY){
		_mainBody = JSON.parse(_MAINBODY);  
	}
	
	changeTitle(_mainBody, to);  
	
	if(to.query.authToken){
		_MAINBODY = null;
		localStorage.removeItem('MAINBODY');
		//console.log("==========已存在AuthToken,清空已存在authToken");
	}
	
	if(!_MAINBODY){
		// 首次扫码或链接打开系统  初始化mainBody信息
		//if('/' == to.path && to.query.authToken){ 
		if(to.path && to.query.authToken){ 	
			 
			//console.log("+++++++++++初始化authToken"); 
			 
			axios.get("/mainBody/initMainBody/"+ to.query.authToken).then((res)=>{ 
				//
				if(2000 == res.code){
					_mainBody = res.content;  
					localStorage.setItem("MAINBODY", JSON.stringify(_mainBody));    
					 
					//console.log('axios-> next');
					
					localStorage.setItem('JUMPTOURL', to.path);
					 
					next('/jumper');
				}else{
					//console.log(res.msg);
					next('/error');
				}  
			}).catch((err)=>{
				//console.log(err) 
				next('/error');
			}) 
		}else if('/error'==to.path){  
			 next();
			 return; 
		}else{
			//console.log(to) 
			if(to.path != from.path){
				next('/error'); 
			}else{
				//console.log("已在这里  不走了")
			}
			 
		} 
		
	}else{
		 
		if(to.path === '/login'){
			next();
		}else{
			let _token = localStorage.getItem('TOKEN');
			if(_token === null || '' === _token){
				//console.log('路由守卫检验：无TOKNE');
				//next('login');
				
				//console.log('正常next()');
				
				next();
			}else{
				next();
			}
		}  
		 
	}
	  
 });

export default router
